import { NotificationDispatch } from '@tryhackme/thm-ui-components';
import { useEffect } from 'react';
import { addSocketListener, removeSocketListener } from 'src/common/sockets';

/**
 * Payload structure for force logout socket events
 */
export interface ForceLogoutPayload {
  message: string;
}
export const ForceLogoutListener = () => {
  useEffect(() => {
    const handleForceLogout = (data: ForceLogoutPayload) => {
      NotificationDispatch('info', data.message || 'You have been logged out');
      window.location.href = '/login';
    };
    addSocketListener('force-logout', handleForceLogout);
    return () => {
      removeSocketListener('force-logout');
    };
  }, []);
  return null;
};